// extracted by mini-css-extract-plugin
module.exports = {"footer":"modalfooter_footer__1lerR"};